export default "__VITE_ASSET__220c7211__"